<template>
    <v-form ref="form" @submit="submit" v-model="formValid" style="height: 100%">
        <div class="title-config">
            <div class="title">{{ $f.tc('callTreatment') }}</div>
            <div style="display: flex; align-items: center">
                <div class="btn-outline" style="margin-right: 8px" @click="addItem()">
                    <img src="/img/add-blue.svg" style="margin-right: 6px; transform: scale(1.1)">
                    {{ $t('addNew') }}
                </div>
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
            </div>
        </div>
        <!--Table config call treatment-->
        <div class="fci-scrollbar config-content">
            <!--No Data-->
            <div style="text-align: center; font-size: 14px; color: #96ADD0; padding: 20px"
                 v-if="itemList.length === 0">
                {{ $f.tc('noDataAvailable') }}
            </div>
            <div v-else>
                <div v-for="(item, index) in itemList" :key="index" class="config-item">
                    <div style="display: flex; align-items: center; width: 100%;border-bottom: 1px dashed #e4edfa">
                        <!--Form call treatment-->
                        <div style="border-right: 1px dashed #e4edfa; flex: 1; padding: 20px">
                            <div class="label">{{ $f.tc('actionCodes') }}</div>
                            <ScenarioComboBox
                                style=""
                                v-model="item.action_codes"
                                :multiple="true"
                                class="custom-combobox"
                            ></ScenarioComboBox>
                            <v-layout align-center style="margin-top: 12px">
                                <v-flex xs4>
                                    <div class="label">{{ $f.tc('nextAction') }}</div>
                                    <v-select
                                        v-model="item.next_action"
                                        :items="nextActionList"
                                        :rules="formRules.required"
                                        class="input-custom"
                                        item-value="key"
                                        item-text="value"
                                    ></v-select>
                                </v-flex>
                                <v-flex xs4>
                                    <div class="label" style="font-weight: 700; font-size: 14px;">{{
                                            $f.tc('cycle')
                                        }}
                                    </div>
                                    <v-text-field
                                        type="number"
                                        outlined
                                        v-model="item.cycle"
                                        :min="0"
                                        :rules="[formRules.ruleRequired, formRules.rulePositiveNumber]"
                                        class="input-custom"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <div class="label" style="font-weight: 700; font-size: 14px;">
                                        {{ $f.tc('interval') }}
                                    </div>
                                    <v-text-field
                                        type="number"
                                        outlined
                                        v-model="item.interval"
                                        :min="0"
                                        :rules="[formRules.ruleRequired, formRules.rulePositiveNumber]"
                                        class="input-custom"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </div>
                        <!--Action for item-->
                        <div class="display-flex align-center justify-center" style="width: 52px;">
                            <v-btn icon @click="removeItem(index)">
                                <img src="/img/delete-blue.svg" style="transform: scale(1.2)">
                            </v-btn>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import BaseConfig from "@/views/Campaign/Form/Step4/BaseConfig";
import CampaignService from "@/services/campaign.service";
import ScenarioComboBox from "@/views/Scenario/components/ScenarioComboBox";

export default {
    name: "CallTreatmentConfig",

    components: {ScenarioComboBox},
    extends: BaseConfig,
    data() {
        return {
            nextActionList: [
                {
                    'key': 'redial',
                    'value': this.$f.tc('redial')
                },
                {
                    'key': 'next_phone_number',
                    'value': this.$f.tc('nextPhoneNumber')
                }
            ],
            emptyItem: {
                next_action: '',
                cycle: '',
                action_codes: '',
                interval: ''

            },
            loadFn: CampaignService.getCTConfig,
            saveFn: CampaignService.addCTConfig,
            updateFn: CampaignService.updateCTConfig,
            deleteFn: CampaignService.deleteCTConfig
        }
    },
    computed: {
        itemTranslate() {
            return this.$t('callTreatment')
        }
    },
}
</script>
<style lang="scss" scoped>
.title-config {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.row-config {
    display: flex;
    align-items: center;

    .config-next-action, .config-action-code, .config-cycle, .config-interval {
        width: 200px;
        margin-right: 8px;
    }

    .config-action {
        width: 28px;
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 10px;
    }

    .v-input__slot {
        margin-bottom: 0 !important;
    }

    .v-select {
        .v-text-field__details {
            right: 30px;
            top: 9px;
        }

        .v-input__slot {
            padding: 6px 3px 6px 12px;
        }
    }

    .custom-combobox {
        .v-input__slot {
            padding: 6px 0 0 0;
        }

        .v-input__append-inner {
            display: none;
        }
    }
}
</style>
